module.exports = __webpack_public_path__ + "img/user.af384a01.svg";